import { generateCorrelationId, RequestData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface PromptRequest extends RequestData {
    type: '@stemcstudio/modal-dialog-service:prompt';
    title: string;
    message: string;
    text: string;
    label: string;
    hint: string;
    /**
     * The cancel button text. Defaults to 'Cancel'.
     */
    cancelButtonText?: string;
    /**
     * The action button text. Defaults to 'OK'.
     */
    actionButtonText?: string;
}

/**
 * @hidden
 */
export function isPromptRequest(message: MessageEvent): message is MessageEvent<PromptRequest> {
    const duck = message as MessageEvent<PromptRequest>;
    if (duck.data.type && duck.data.type === '@stemcstudio/modal-dialog-service:prompt') {
        return true;
    } else {
        return false;
    }
}


/**
 * @hidden
 */
export function createPromptRequest(title: string, message: string, text: string, label: string, hint: string, actionButtonText: string, cancelButtonText: string): PromptRequest {
    const id = generateCorrelationId();
    return {
        type: '@stemcstudio/modal-dialog-service:prompt',
        id,
        title,
        message,
        text,
        label,
        hint,
        actionButtonText: actionButtonText,
        cancelButtonText: cancelButtonText
    };
}

